// SupportBox.js
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { supportTicket } from "../utils/logsApi";
import "../App.css";
import Modal from "./Modal";

const SupportBox = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [modal, setModal] = useState({
        isOpen: false,
        title: "",
        message: "",
        type: "info",
        onConfirm: null,
    });

    const userEmail = localStorage.getItem("userEmail");

    const openModal = (title, message, type = "info", onConfirm = null) => {
        setModal({ isOpen: true, title, message, type, onConfirm });
    };

    const closeModal = () => {
        setModal({ isOpen: false, title: "", message: "", type: "info", onConfirm: null });
    };

    const handleSend = async () => {
        if (!message.trim()) {
            openModal("Validation Error", "Please enter a message.", "info");
            return;
        }

        try {
            await supportTicket(userEmail, message);
            openModal("Success", "Your message has been sent successfully!", "info");
            setMessage("");
            setIsOpen(false);
        } catch (error) {
            console.error("Failed to send support request:", error);
            openModal("Error", "Failed to send support request. Please try again.", "info");
        }
    };

    return (
        <div>
            <button className="support-icon" onClick={() => setIsOpen(!isOpen)}>
                <FontAwesomeIcon icon={faComments} />
            </button>

            {isOpen && (
                <div className="support-box">
                    <textarea
                        placeholder="Describe your issue here..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        className="support-textarea"
                    />
                    <button className="send-button" onClick={handleSend}>
                        Send
                    </button>
                </div>
            )}

            <Modal
                isOpen={modal.isOpen}
                title={modal.title}
                message={modal.message}
                type={modal.type}
                onClose={closeModal}
            />
        </div>
    );
};

export default SupportBox;
